import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  PARENT_PACKAGE_LIST_PARAMS_REQUEST,
  PARENT_PACKAGE_LIST_STATE,
} from 'models/parent-package';

export interface ParentPackageOverviewState {
  parent_package_overview: PARENT_PACKAGE_LIST_STATE;
}

const initialState: ParentPackageOverviewState = {
  parent_package_overview: {
    records: [],
    metadata: {
      page: 1,
      limit: 50,
      page_count: 1,
      total_pages: 1,
      total_count: 1,
    },
    params: { page: 1, limit: 50 },
  },
};

const parentPackageSlice = createSlice({
  name: 'parentPackage',
  initialState,
  reducers: {
    setParentPackageListSuccess(
      state: ParentPackageOverviewState,
      action: PayloadAction<PARENT_PACKAGE_LIST_STATE>
    ) {
      state.parent_package_overview = {
        ...state.parent_package_overview,
        ...action.payload,
      };
    },
    setParentPackageListParams(
      state: ParentPackageOverviewState,
      action: PayloadAction<PARENT_PACKAGE_LIST_PARAMS_REQUEST | null>
    ) {
      state.parent_package_overview.params = action.payload;
    },
  },
});

// Actions
export const { setParentPackageListSuccess, setParentPackageListParams } =
  parentPackageSlice.actions;

export default parentPackageSlice.reducer;
